export const ignitePrompts = [
  {
    text: `I'm Searching for Attachments`,
    children: [
      {
        text: `Show me some Attachments`,
        parentText: "I'm Searching for Attachments"
      },
      {
        text: `Help me Find the Right Fit`,
        parentText: "I'm Searching for Attachments",
        children: [
          {
            text: `Submit Bulk Attachments Request`,
            parentText: 'Help me Find the Right Fit'
          }
        ]
      },
      {
        text: `Submit Bulk Attachments Request`,
        parentText: "I'm Searching for Attachments"
      }
    ]
  },
  {
    text: `I'm Searching for Parts`,
    children: [
      {
        text: `Submit Bulk Parts Request`,
        parentText: "I'm searching for Parts"
      },
      {
        text: `Show me some Parts`,
        parentText: "I'm Searching for Parts"
      },
      {
        text: `Help me Find the Right Fit`,
        parentText: "I'm searching for Parts",
        children: [
          {
            text: `Submit Bulk Parts Request`,
            parentText: 'Help me Find the Right Fit'
          }
        ]
      }
    ]
  },
  {
    text: `I'm Searching for Implements`,
    children: [
      {
        text: `Show me some Implements`,
        parentText: "I'm searching for Implements"
      },
      {
        text: `Help me Find the Right Fit`,
        parentText: "I'm searching for Implements",
        children: [
          {
            text: `Submit Bulk Implements Request`,
            parentText: 'Help me Find the Right Fit'
          }
        ]
      }
    ]
  },
  {
    text: `I Need Help With My Order`,
    children: [
      {
        text: `Help With a Return`,
        parentText: 'I Need Help With My Order'
      },
      {
        text: `Tracking my Order`,
        parentText: 'I Need Help With My Order'
      }
    ]
  },
  {
    text: `Speak to an Ignite Attachments Especialist`
  },
  {
    text: `Interested In Reselling`
  },
  {
    text: `Something Else`,
    children: [
      {
        text: `Contact Information`,
        parentText: 'Something Else'
      },
      {
        text: `Submit a Warranty Claim`,
        parentText: 'Something Else'
      },
      {
        text: `Find a Reseller`,
        parentText: 'Something Else'
      }
    ]
  }
]
